<template>
	<el-dialog
	  :title="dataForm.type==3?'共享开发环境-申请上线运行':'专享开发环境-申请上线运行'"
	  :visible.sync="dialogVisible"
	  width="40%">
	  <el-form :model="dataForm" inline ref="dataForm" :inline="false" :rules="rules">
		   <el-form-item label="环境名称" label-width="100px">
			  <el-input disabled  v-model="title"></el-input>
		   </el-form-item>
		   <el-form-item label="存续时长" label-width="100px" prop="cunxu">
			   <el-input placeholder="存续时长(1-10)" v-model="dataForm.cunxu" type="number">
				   <template slot="append">年</template>
			   </el-input>
		   </el-form-item>
		   <el-form-item label="" label-width="100px" prop="yunxings">
		   	  <el-button type="primary" size="small" icon="el-icon-plus" @click="add">添加上线运行节点</el-button>
		   </el-form-item>
		   <el-form-item v-for="(item,i) in dataForm.shangxians" :key="i" :label="'运行节点' + (i+1)" label-width="100px" prop="shangxians">
			   <div style="width: 100%;display: flex;align-items: center;margin-bottom: 10px;">   
					<span style="width: 131px;text-align: right;">
						<span style="color: red;">*</span>
						IP：
					</span>
				   <el-input placeholder="请输入" v-model="item.ip" style="margin-left: 7px;"></el-input>
			   </div>
			   <div style="width: 100%;">
				   <span style="width: 110px;text-align: right;">
					   <span style="color: red;">*</span>
					   运行保障级别：
				   </span>
				   <el-select v-model="item.baozhangid" placeholder="请选择">
				       <el-option
				         v-for="item in baozhangarr"
				         :key="item.id"
				         :label="item.title"
				         :value="item.id">
				       </el-option>
				     </el-select>
			   </div>
			   <el-button type="danger" size="small" style="margin-top: 20px;" @click="dataForm.shangxians.splice(i,1)">移除</el-button>
		   </el-form-item>
		   <div style="width: 100%;display: flex;align-items: center;justify-content: center;">
		   			   <el-checkbox v-model="checked"></el-checkbox>
		   			   <a style="margin-left: 5px;" href="https://www.metabiz.com.cn/html/shangxianyunxing.html" target="_blank">我已仔细阅读并接受SasS最终用户协议(点击链接查看协议内容)</a>
		   </div>
		   <div style="width: 100%;display: flex;align-items: center;justify-content: center;margin-top: 20px;">
			   <el-button type="success" @click="user_yunxing_save">
					确认申请
			   </el-button>
		   </div>
	  </el-form>
	</el-dialog>
</template>

<script>
	import { baozhangjibie_list,user_yunxing_save } from "@/api/huanjing"
	export default {
		data(){
			return{
				checked:false,
				dialogVisible:false,
				dataForm:{
				   huanjingid:'',//环境id
				   type:3,//3共享 4专享
				   cunxu:'',//存续时长
				   yunxingtype:2,
				   shangxians:[
					   {
						ip:'',
						baozhangid:''
					   }
				   ]
				},
				rules:{
				   cunxu:[{ required: true, message: '存续时长不能为空', trigger: 'blur' }],
				   shangxians:[{ required: true, message: '运行保障级别必填写', trigger: 'blur' }]
				},
				baozhangarr:[],//保障级别id
				title:''
			}
		},
		watch:{
			["dataForm.cunxu"](e){
				if(e<1){
					this.dataForm.cunxu = 1
				}
				if(e>10){
					this.dataForm.cunxu = 10
				}
			},
			dialogVisible(e){
				if(e==false){
					this.title = ''
					this.dataForm = {
						   huanjingid:'',//环境id
						   type:3,//3共享 4专享
						   cunxu:'',//存续时长
						    yunxingtype:2,
						  shangxians:[
							   {
								ip:'',
								baozhangid:''
							   }
						  ]
					   }
				}
			},
		},
		methods:{
			user_yunxing_save(){
				let that = this;
				if(!that.checked){
					this.$message.error("请勾选协议");
					return;
				}
				that.$refs['dataForm'].validate((valid) => {
					if (valid) {
						let shangxians = that.dataForm.shangxians;
						let is = 1;
						shangxians.forEach(r=>{
							if(!r.ip || !r.baozhangid){
								is = 0;
							}
						})
						if(is==0){
							that.$message.error("ip和运行保障级别必填");
							return;
						}
						console.log("请求参数",that.dataForm);
						const loading = this.$loading({
						  lock: true,
						  text: '申请中',
						  spinner: 'el-icon-loading',
						  background: 'rgba(0, 0, 0, 0.7)'
						});
						user_yunxing_save(that.dataForm).then(res=>{
							loading.close();
							that.dialogVisible = false
							that.$message.success("申请成功");
							that.$emit("shangxiansucc",res.data.orderid);
						}).catch(()=>{
							loading.close();
						})
					}
				})
			},
			show(item){
				console.log("item",item);
				this.$nextTick(()=>{
					this.dialogVisible = true
					this.dataForm.huanjingid = item.id
					this.dataForm.type = item.type
					this.title = item.title
					this.baozhangjibie_list();
				})
			},
			baozhangjibie_list(){
				baozhangjibie_list({}).then(res=>{
					console.log("运行保障级别列表",res.data);
					this.baozhangarr = res.data
				})
			},
			add(){
				this.dataForm.shangxians.push({
					ip:'',
					baozhangid:''
				})
			},
		},
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/yunxing/shangxian.vue